import { updateFumigationCompanyService } from "services/updateFumigationCompany.service";
import { FumigationCompanyPayload, FumigationCompanyDetail } from "services/fumigationCompany.types";
import { useMutation } from "react-query";
import { AxiosError } from 'axios';

// PUT /fumigator-details -> server responds with { data: <updated row> }
export interface UpdateFumigationCompanyResponse {
    data: FumigationCompanyDetail;
}

export const useUpdateFumigationCompany = () => {

    return useMutation<UpdateFumigationCompanyResponse, AxiosError, FumigationCompanyPayload>(updateFumigationCompanyService);

}

export default useUpdateFumigationCompany;
